import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import AnnouncementBar from '../../../components/feature/AnnouncementBar';

const Navbar = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const navItems = [
    { name: 'Home', path: '/' },
    { name: 'Inventory', path: '/inventory' },
    { name: 'Financing', path: '/financing' },
    { name: 'About', path: '/about' },
    { name: 'Contact', path: '/contact' },
  ];

  return (
    <nav
      className={`fixed left-0 right-0 top-0 z-50 transition-all duration-500 bg-[#0d0d0d] ${
        isScrolled ? 'shadow-lg shadow-black/30' : ''
      }`}
    >
      {/* Nav row */}
      <div className={`w-full px-4 sm:px-8 lg:px-12 transition-all duration-500 py-2`}>
        <div className="flex items-center justify-between">
          <Link to="/" className="flex items-center gap-2 sm:gap-3 cursor-pointer group">
            <img
              src="https://static.readdy.ai/image/41574e0492e980fd88e2c6f8d59234d9/7d1f372df28459c5713c0f3e160d8f18.png"
              alt="Paramount Motors Logo"
              style={{ height: '5rem', width: 'auto' }}
              className="object-contain"
            />
          </Link>

          <div className="hidden lg:flex items-center gap-8">
            {navItems.map((item) => (
              <Link
                key={item.name}
                to={item.path}
                className="text-sm font-medium tracking-widest uppercase text-white hover:text-[#C9A84C] transition-all duration-300 cursor-pointer relative group"
                style={{ fontFamily: 'Montserrat, sans-serif', fontSize: '11px' }}
              >
                {item.name}
                <span className="absolute -bottom-1 left-0 w-0 h-px bg-[#C9A84C] group-hover:w-full transition-all duration-300"></span>
              </Link>
            ))}
          </div>

          <div className="hidden lg:flex items-center gap-4">
            <Link
              to="/financing"
              className="px-6 py-2.5 rounded-sm text-xs font-semibold tracking-widest uppercase transition-all cursor-pointer whitespace-nowrap hover:scale-105 transform bg-[#C9A84C] text-[#0d0d0d] hover:bg-[#e0bc5e]"
              style={{ fontFamily: 'Montserrat, sans-serif' }}
            >
              Financing
            </Link>
          </div>

          <button
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
            className="lg:hidden relative z-50 w-10 h-10 flex items-center justify-center cursor-pointer bg-[#C9A84C] rounded-sm hover:bg-[#e0bc5e] transition-colors"
          >
            <i
              className={isMobileMenuOpen ? 'fa-solid fa-xmark' : 'fa-solid fa-bars'}
              style={{ color: '#0d0d0d', fontSize: '18px' }}
            ></i>
          </button>
        </div>

        {isMobileMenuOpen && (
          <div className="lg:hidden mt-4 sm:mt-6 pb-4 sm:pb-6 border-t border-white/10 pt-4 sm:pt-6">
            <div className="flex flex-col gap-4 sm:gap-5">
              {navItems.map((item) => (
                <Link
                  key={item.name}
                  to={item.path}
                  onClick={() => setIsMobileMenuOpen(false)}
                  className="text-xs font-medium tracking-widest uppercase text-[#C9A84C] hover:text-[#e0bc5e] transition-all duration-300 cursor-pointer"
                  style={{ fontFamily: 'Montserrat, sans-serif' }}
                >
                  {item.name}
                </Link>
              ))}
              <Link
                to="/financing"
                onClick={() => setIsMobileMenuOpen(false)}
                className="mt-2 px-6 py-3 rounded-sm text-xs font-semibold tracking-widest uppercase bg-[#C9A84C] text-[#0d0d0d] cursor-pointer whitespace-nowrap text-center"
              >
                Financing
              </Link>
            </div>
          </div>
        )}
      </div>

      {/* Gold accent divider */}
      <div className="h-px bg-gradient-to-r from-transparent via-[#C9A84C]/50 to-transparent"></div>

      {/* Announcement bar sits right below the nav */}
      <AnnouncementBar />
    </nav>
  );
};

export default Navbar;